import script from './select-dropdown.vue_vue_type_script_lang.mjs';
export { default } from './select-dropdown.vue_vue_type_script_lang.mjs';
import { render } from './select-dropdown.vue_vue_type_template_id_46cf6eee_lang.mjs';

script.render = render;
script.__file = "packages/components/select/src/select-dropdown.vue";
//# sourceMappingURL=select-dropdown.mjs.map
